import {extendCrudApiByHousehold} from '@/utils/api.js';

const mealLogApi = extendCrudApiByHousehold({
  entityNameSingular: 'MealLogEntry',
  entityNamePlural: 'MealLogEntries',
  entityPath: 'meal-log-entries',
});

export const {
  useGetMealLogEntriesQuery,
  useGetMealLogEntryQuery,
  useUpdateMealLogEntryMutation,
  useDeleteMealLogEntryMutation,
  useCreateMealLogEntryMutation,
} = mealLogApi;
